import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { MessageCircle, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "h-14 w-full rounded-md border-0 bg-white px-5 text-sm text-seed-deep shadow-[0_1px_3px_rgba(0,76,63,0.08)] outline-none transition-shadow duration-300 placeholder:text-seed-deep/40 focus:shadow-[0_0_0_2px_#00D765]";

export const Contact = () => {
  const [form, setForm] = useState({ nome: "", telefone: "", email: "", interesse: "Imóvel Urbano", mensagem: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const origem = new URLSearchParams(window.location.search).get("utm_source") || "site";
      await axios.post(`${API}/leads`, { ...form, origem });
      toast.success("Recebemos seu contato! Retornaremos em breve.");
      setForm({ nome: "", telefone: "", email: "", interesse: "Imóvel Urbano", mensagem: "" });
    } catch {
      toast.error("Não foi possível enviar. Tente pelo WhatsApp.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contato" className="bg-white py-24 md:py-36" data-testid="contact-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-2 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.25em] text-seed-salad">Contato</p>
          <h2 className="font-heading text-4xl font-black leading-[1.05] tracking-tighter text-seed-deep sm:text-5xl" data-testid="contact-title">
            Vamos plantar o seu próximo capítulo?
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-seed-deep/70">
            Fale direto com quem entende do assunto. Atendimento humano, resposta rápida e zero burocracia.
          </p>
          <a
            href="https://wa.me/5534999236969?text=Ol%C3%A1!%20Quero%20falar%20com%20a%20Seed%20Im%C3%B3veis."
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-cta"
            className="mt-10 inline-flex items-center gap-3 rounded-full bg-seed-vivid px-10 py-5 font-heading text-lg font-black text-seed-deep transition-transform duration-300 hover:scale-105"
          >
            <MessageCircle size={22} strokeWidth={2.5} />
            34 99923-6969
          </a>
          <p className="mt-4 text-xs font-semibold uppercase tracking-widest text-seed-deep/40">
            WhatsApp e ligações · Seg a Sáb
          </p>
        </motion.div>

        <motion.form
          onSubmit={submit}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="space-y-5 rounded-lg bg-seed-off p-8 md:p-10"
          data-testid="contact-form"
        >
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <input required placeholder="Seu nome" value={form.nome} onChange={set("nome")} className={inputCls} data-testid="form-nome" />
            <input required placeholder="Telefone" value={form.telefone} onChange={set("telefone")} className={inputCls} data-testid="form-telefone" />
          </div>
          <input type="email" placeholder="E-mail (opcional)" value={form.email} onChange={set("email")} className={inputCls} data-testid="form-email" />
          <select value={form.interesse} onChange={set("interesse")} className={inputCls} data-testid="form-interesse">
            <option>Imóvel Urbano</option>
            <option>Imóvel Rural</option>
            <option>Avaliação de Imóvel</option>
            <option>Consultoria</option>
          </select>
          <textarea
            placeholder="Conte o que você procura..."
            value={form.mensagem}
            onChange={set("mensagem")}
            rows={4}
            className={`${inputCls} h-auto py-4`}
            data-testid="form-mensagem"
          />
          <button
            type="submit"
            disabled={sending}
            data-testid="form-submit"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-seed-deep py-4 font-heading text-sm font-bold text-seed-off transition-transform duration-300 hover:scale-[1.02] disabled:opacity-60"
          >
            <Send size={16} />
            {sending ? "Enviando..." : "Enviar mensagem"}
          </button>
        </motion.form>
      </div>
    </section>
  );
};
